/**
 * @generated SignedSource<<12e4a6b4f8d0767dc88dcf315125a456>>
 * @relayHash c898288295208f746b7a53f1277cbec2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 59a879e87ee79733a1c03cbece7acfbb2ead1351fc47522651388ff340040056

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "59a879e87ee79733a1c03cbece7acfbb2ead1351fc47522651388ff340040056",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
